import SearchLocation from './searchLocation';

export default SearchLocation;
